import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProjectProvider } from "@/context/ProjectContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppShell from "@/components/AppShell";

import Login from "@/pages/Login";
import Setup from "@/pages/Setup";
import Overview from "@/pages/Overview";
import Finance from "@/pages/Finance";
import Closeout from "@/pages/Closeout";
import Production from "@/pages/Production";
import Documents from "@/pages/Documents";
import People from "@/pages/People";
import Settings from "@/pages/Settings";

function Shell({ children }) {
  return (
    <ProtectedRoute>
      <ProjectProvider>
        <AppShell>{children}</AppShell>
      </ProjectProvider>
    </ProtectedRoute>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster theme="dark" position="top-right" richColors />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/setup" element={<Setup />} />
            <Route path="/" element={<Shell><Overview /></Shell>} />
            <Route path="/finance" element={<Shell><Finance /></Shell>} />
            <Route path="/closeout" element={<Shell><Closeout /></Shell>} />
            <Route path="/production" element={<Shell><Production /></Shell>} />
            <Route path="/documents" element={<Shell><Documents /></Shell>} />
            <Route path="/people" element={<Shell><People /></Shell>} />
            <Route path="/settings" element={<Shell><Settings /></Shell>} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
